module.exports = __webpack_public_path__ + "static/military-img-4671e09f8826bc2b4c1dbe345e12c58f.jpg";